import { TableConfig } from '@shared/interfaces/table/table-config';
import { DashboardQueryMeteredDataLockResultDto } from '@app/api/dmc';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { dashboardMeteringPointAddressPartial } from '@shared/columns/dashboard.columns';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';


export const lockedMeteredDataTable: TableConfig<DashboardQueryMeteredDataLockResultDto> = {
  id: 'table-dashboard-locked-metered-data',
  title: 'dashboard.lockedtimeseries.title',
  saveChanges: true,
  exportable: true,
  copyable: true,
  floatingHeader: true,
  pageSize: 50,
  pageSizeSelection: true,
  selectable: true,
  columns: [
    {
      title: 'dashboard.timeseries.missing.dateofwork',
      key: 'occurrence',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'dashboard.table.meteringpointid',
      key: 'meteringPointIdentification',
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/meteringpoint',
        urlReference: 'meteringPointIdentification',
    }
    },
    dashboardMeteringPointAddressPartial,
    meteringPointTypePartial,
  ]
}
